// extracted by mini-css-extract-plugin
module.exports = {"temporaryPinAction":"UserApprovals_temporaryPinAction__2aoNx"};